import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';

import FlexGeneralInfoDialog from './FlexGeneralInfoDialog'
import OptionExpansionPanel from './OptionExpansionPanel'

import { handleSaveNumberOfOptions } from '../actions/rfp'

import t from '../utils/lang'

const styles = theme => ({
  root: {
    width: '100%'
  },
  panelHeader: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    flexBasis: '50%',
    flexShrink: 0,
    '@media screen and (max-width: 500px)': {
      fontSize: '0.8rem',
      flexBasis: '100%',
    }
  },
  panelAnswerQuestions: {
    width: '50%',
    textAlign: 'right',
    '@media screen and (max-width: 500px)': {
      display: 'none'
    }
  },
  questionList: {
    display: 'block'
  },
  dataRow: {
    width: '600px',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    }
  },
  dataLabel: {
    width: '300px',
    lineHeight: '2rem',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    }
  },
  dataLabelFull: {
    width: '100%',
    lineHeight: '2rem',
  },
  dataLabelIndent: {
    width: '280px',
    lineHeight: '2rem',
    paddingLeft: '20px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(60% - 20px)',
    }
  },
  dataValue: {
    width: '300px',
    lineHeight: '2rem',
    fontWeight: '600',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      lineHeight: '1rem',
      marginBottom: '1rem'
    }
  },
  dataValueIndent: {
    width: '300px',
    lineHeight: '2rem',
    fontWeight: '600',
    [theme.breakpoints.down('xs')]: {
      width: '40%',
    }
  },
  button: {
    padding: 0,
    borderRadius: 0
  },
  numberOFOptionsActions: {
    paddingLeft: theme.spacing.unit * 2,
    display: 'inline'
  }
});

class QuestionsFlex extends Component {
  state = {
    lang: 'en',
    openFlexGeneralInfoDialog: false,
    numberOfOptions: null
  }

  handleFlexGeneralInfoDialogOpen = (event) => {
    this.setState({ openFlexGeneralInfoDialog: true });
  }

  handleFlexGeneralInfoDialogClose = () => {
    this.setState({ openFlexGeneralInfoDialog: false });
  }

  handleAddOption = e => {
    const { id, dispatch } = this.props;
    const numberOfOptions = ++this.state.numberOfOptions;

    dispatch(handleSaveNumberOfOptions(id, numberOfOptions));
    this.setState({ numberOfOptions });
  }

  handleRemoveOption = e => {
    const { id, dispatch } = this.props;
    const numberOfOptions = --this.state.numberOfOptions;
    
    dispatch(handleSaveNumberOfOptions(id, numberOfOptions));
    this.setState({ numberOfOptions });
  }

  componentDidMount() {
    const { lang, data } = this.props

    this.setState({ lang: lang ? lang : 'en', numberOfOptions: data.numberOfOptions })
  }

  componentDidUpdate(prevProps) {
    const { lang } = this.props

    if (lang !== prevProps.lang) {
      this.setState({ lang })
    }
  }

	render() {
    const { lang, openFlexGeneralInfoDialog, numberOfOptions } = this.state
		const { id, data, statusId, classes, general, option, answeredQuestions, unansweredQuestions } = this.props
    const optionIndexes = Array.from(Array(parseInt(data.numberOfOptions)).keys());
    const proposalSubmitted = statusId === 3 ? true : false

    //console.log(optionIndexes)

		return (
			<div className={classes.root}>
        <ExpansionPanel defaultExpanded>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.panelHeader}>{t[lang].general}</Typography>
            {/*<Typography className={classes.panelAnswerQuestions}>{`${answeredQuestions.general} ${t[lang].of} ${general.length} ${t[lang].answered}`}</Typography>*/}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.questionList}>
            <div className={classes.dataRow}>
              <Typography className={classes.dataLabel}>{t[lang].numberOfOptions}</Typography>
              <Typography className={classes.dataValue}>{
                numberOfOptions !== null ? numberOfOptions : '-'}
                <div className={classes.numberOFOptionsActions}>
                  <IconButton className={classes.button} size="small" disabled={numberOfOptions == 3} onClick={this.handleAddOption}>
                    <AddBoxOutlinedIcon />
                  </IconButton>
                  <IconButton className={classes.button} size="small" disabled={numberOfOptions == 1} onClick={this.handleRemoveOption}>
                    <IndeterminateCheckBoxOutlinedIcon />
                  </IconButton>
                </div>
              </Typography>
             
            </div>

            <div className={classes.dataRow}>
              <Typography className={classes.dataLabel}>{t[lang].contactPerson}</Typography>
              <Typography className={classes.dataValue}>{data.contactPerson !== null ? data.contactPerson : '-'}</Typography>
            </div>
          </ExpansionPanelDetails>
          <ExpansionPanelActions>
            <Button size="small" color="primary" onClick={event => this.handleFlexGeneralInfoDialogOpen(event)} disabled={proposalSubmitted}>
              {t[lang].edit}
            </Button>
          </ExpansionPanelActions>
        </ExpansionPanel>

        {optionIndexes.map((index) =>
          <OptionExpansionPanel key={index} index={index} classes={classes} />
        )}

        {id && (
          <FlexGeneralInfoDialog open={openFlexGeneralInfoDialog} handleClose={this.handleFlexGeneralInfoDialogClose} />
        )}
      </div>
		)
	}
}

function mapStateToProps ({ rfpData, questions }) {
  const { lang, id, statusId, flexData } = rfpData

  //console.log('FlexData', flexData)

  const categorizedQuestions = {
    'general': Object.values(questions).filter((q) => q.categoryId === "5"),
    'option': Object.values(questions).filter((q) => q.categoryId === "6"),
  }

  const answeredQuestions = {
    'general': categorizedQuestions.general.filter((q) => q.answer !== '').length,
    'option': categorizedQuestions.option.filter((q) => q.answer !== '').length,
  }

  const unansweredQuestions = {
    'general': categorizedQuestions.general.length - answeredQuestions.general,
    'option': categorizedQuestions.option.length - answeredQuestions.option,
  }

  return {
    general: categorizedQuestions.general,
    option: categorizedQuestions.option,
    answeredQuestions,
    unansweredQuestions,
    lang,
    id,
    statusId,
    data: flexData
  }
}

export default withStyles(styles)(connect(mapStateToProps)(QuestionsFlex))


// WEBPACK FOOTER //
// ./src/components/QuestionsFlex.js